const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/class",
    exact: true,
    component: "ClassBuds",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
  {
    path: "/tally/:language/:filename",
    exact: true,
    component: "DocViewer",
  },
];

export default routes;
